/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

import
{
    updateBillTo as updateBillToApi,
    UpdateBillToApiParameter,
} from "@insite/client-framework/Services/CustomersService";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<UpdateBillToApiParameter & HasOnSuccess, BillToModel>;

export const PopulateApiParameter: HandlerType = props =>
{
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props =>
{
    props.apiResult = await updateBillToApi(props.apiParameter);
};

export const chain = [
    PopulateApiParameter,
    SendDataToApi
];

const updateBillToOnCheckout = createHandlerChainRunner(chain, "updateBillToOnCheckout");
export default updateBillToOnCheckout;
